<template>
        <div id="chart" style="width:100%;height:100%;"></div>
</template>

<script>
    import store from '../../store.js';
    import { mapGetters } from 'vuex';
    // import datalabels from 'chart.piecelabel.js';
    import HighCharts from 'highcharts';
    // Chart.plugins.register(datalabels);

    export default {
        props: {
            updateChart: {default: false},
            displayLegend: { default: () => false },
            chartTitle: { default: () => store.state.indicator.name },
            legendLabel: { default: 'Default Legend Label' }
        },
        mounted () {
            let options  = {
                "chart": {
                    'plotBackgroundColor': null,
                    'plotBorderWidth': null,
                    'plotShadow': false,
                    'type': 'line'
                },
                'plotOptions': {
                  'pie': {
                    // 'allowPointSelect': true,
                    // 'cursor': 'pointer',
                    'center': ['50%', '50%'],
                    'dataLabels': {
                      'enabled': true,
                      'format': '<b>{point.name}</b> - <b>{point.percentage:.2f}%</b>',
                      'style': {
                        'color': 'black'
                      }
                    }
                  }
                },
                "title": {
                    "text": this.chartTitle
                },
                "subtitle": {
                    "text": this.getSelectedMea.name
                },
                "series": [
                  {
                    "name": this.chartTitle,
                    "data": this.getNewChartData
                  }
                ],
                 "xAxis": {
                    "min": null,
                    'allowDecimals': true,
                    "type": 'category',
                    "labels": {
                      "rotation": -45,
                      "style": {
                        "fontSize": '13px',
                        "fontFamily": 'Roboto, sans-serif',
                      }
                    }
                  },
                  "yAxis": {
                    // "tickInterval": 1,
                    max: this.max,
                    "min": null,
                    "labels": {
                        "format": '{value:.2f}'
                    },
                    "title": {
                      "text": store.state.indicator.unit
                    }
                  },
            }
            this.chart = HighCharts.chart('chart', options);
        },
        watch: {
          getSelectedYear: function(year){
            this.refreshChart();
          },
          chartType: function (val) {
             let options = {
                "chart": {
                    "type": val
                }
            }
            if (val !== 'pie') {
              options['plotOptions'] = {}
            }
            this.chart.update(options);
           },
          updateChart: function(val){
            if (val){
              this.refreshChart()
            }
          }
        },
        data () {
            return {
                chart: null,
            }
        },
        computed: {
          axisTitle: function () {
              if (this.getDataType === 'xls' || this.getDataType === 'xlsx'){
                 return "CH₄ emission (Gg)"
              }else if (this.getDataType == 'shp'){
                return "Area (sq. km)"
              }
          },
          max: function() {
           return Math.max.apply(Math, this.getNewChartData.map(function(o) { return o.y; }))
          },
            chartType: () => store.state.chartType,
            getTruncatedLabels: function(){
                return this.getLabels.map(function(label){
                    return label.slice(0, 5) + "...";
                });
            },
            ...mapGetters([
              'getDataType',
              'getSelectedYear',
              'getChartData',
              'getLabels',
              'getNewChartData',
              'getSelectedMea'
            ])
        },

        methods: {
          refreshChart: function() {
            if (this.chart) {
              this.chart.series[0].remove();
              this.chart.addSeries({
                  'data': this.getNewChartData,
                  'name': this.chartTitle
                },
                true);
              this.chart.yAxis[0].setExtremes(0, this.max);
              this.updateChart = false;
            }
          }
        }
    };

</script>

<style scoped lang="scss">
  template {
    fontFamily: 'Roboto', sans-serif;
  }
  // canvas {
  //   width: 100%;
  //   height:100%;
  //   padding: 0;
  //   margin: 0;
  // }
</style>



// WEBPACK FOOTER //
// src/components/report/ChartDisplay.vue